import React from 'react';

import { EventHandlerComponentProps } from '@/hooks/useEventHandler/types';
import ShareDialog from '@/modules/lyearn-connect/components/ShareDialog';
import { EventUnion } from '@/types/schema';

import useShareSession from './useShareSession';

export type ShareSessionDialogProps = {
  event: EventUnion;
};

export default function ShareSessionDialog({
  event,
  onClose,
}: ShareSessionDialogProps & EventHandlerComponentProps) {
  const { alreadySharedConnections, onSubmit, fetching } = useShareSession({
    event,
    onClose,
  });

  return (
    <ShareDialog
      alreadySharedWorkspaceIds={alreadySharedConnections}
      fetching={fetching}
      type="session"
      onClose={onClose}
      onShare={onSubmit}
    />
  );
}
